import { Pipe, PipeTransform } from '@angular/core';

import { toKebabCase } from '../utils/string.utils';

@Pipe({ name: 'kebabCase', standalone: true })
export class KebabCasePipe implements PipeTransform {
  /**
   * Converts a string to kebab-case, delegating to the shared toKebabCase util
   * so the pipe and the util can never drift.
   * Note the value is not trimmed - trim on the binding when leading/trailing
   * whitespace should not become a hyphen.
   * @param value - The string to convert
   * @returns The kebab-cased string
   */
  transform(value: string): string {
    return toKebabCase(value);
  }
}
